import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// api
import * as platform_resourceAPI from 'api/platform_resource';
import * as platform_resourceTypes from 'types/platform_resource';

// ----------------------------------------------------------------------

type platform_resource = {
  loading: boolean;
  searchResults: any[];
  platformResourceList: any;
};

const initialState: platform_resource = {
  loading: false,
  searchResults: [],
  platformResourceList: { rows: [], total: -1 }
};

const slice = createSlice({
  name: 'platform_resource',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },
    setSearchResults(state, action) {
      state.searchResults = action.payload;
    },
    setPlatformResourceList(state, action) {
      state.loading = false;
      const { rows = [], total = 0, append = false } = action.payload;

      const { platformResourceList } = state;

      if (append && platformResourceList?.rows) {
        state.platformResourceList = {
          rows: [...platformResourceList.rows, ...rows],
          total
        };
      } else {
        state.platformResourceList = { rows, total };
      }
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
// export const { setCourseFolderId, addBreadcrumb, goToBreadcrumb, clearBreadcrumbs } = slice.actions;

// action

// slices 文件
export function search(params: platform_resourceTypes.search_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, offset = 0, ...rest } = params;
    try {
      const response = await platform_resourceAPI.search({ ...rest, offset });
      console.log(response);

      // 自动判断 append 模式
      const append = offset > 0;
      dispatch(
        slice.actions.setPlatformResourceList({
          ...response,
          append
        })
      );

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

export function ai_search(params: platform_resourceTypes.search_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, finallyCallback, offset = 0, ...rest } = params;
    try {
      const response = await platform_resourceAPI.ai_search({ ...rest, offset });
      console.log(response);

      // 自动判断 append 模式
      const append = offset > 0;
      dispatch(
        slice.actions.setPlatformResourceList({
          ...response,
          append
        })
      );

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    } finally {
      if (finallyCallback) {
        finallyCallback();
      }
    }
  };
}
